
import { Link } from 'react-router-dom'

export default function Example({ navigation }) {
  return (
    <div className='py-6'>     
        <nav aria-label="Sidebar" className="flex items-center flex-col">
            <ul role="list" className="-mx-2 space-y-4">
                {navigation.map((item) => (
                    <Link to={item.to} key={item.name} className='flex border-2 border-gray-300 p-3 shadow-md rounded-xl'>
                        
                        <div className='inline w-14'>
                            <item.icon aria-hidden="true" className="h-6 w-6 text-orange-500" />
                        </div>

                        <div className='inline ml-2 font-bold'>
                            {item.name}
                        </div>
                        
                    </Link>
                ))}
            </ul>
        </nav>      
    </div>
  )
}
